
import { map } from 'rxjs/operators';
import { Component, OnInit, Input, EventEmitter, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { NgForm, AbstractControl }   from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';

import { GDSCredentials, DefaultsService, CustomerModel, ContractModel, initCustomerModel, CustomersService } from '../../../../core'
import { CustomersStateService } from '../../shared/customers-state.service';
import { PopupSettings } from '@progress/kendo-angular-dropdowns';
import { UserProfileService } from '../../../../core';

@Component({
  selector: 'app-add-edit-customer',
  templateUrl: './add-edit-customer.component.html',
  styleUrls: ['./add-edit-customer.component.scss']
})
export class AddEditCustomerComponent implements OnInit, OnDestroy {
  @ViewChild('customerForm', { static: true }) customerForm:NgForm;
  customerID: number | string = '';
  chainCodeList: string = ""
  subscriptions: Subscription[] = [];
  inEditMode: boolean = false;
  accountLinked: boolean ;
  accountList: Array<{ channelID: number, clientID: number, customerNumber: string, name: string, type: string, isTest: boolean }> = [];
  disableChainCodes: boolean = true;
  enableQuickAuditCheckBox: boolean;
  highlightInvalidEntries:boolean;

  updateChainCodeList() {
    let commaString: string = this.chainCodeList;

    let rre = /[^A-Z0-9,]/g;
    let list = commaString.toUpperCase().replace(rre, '').split(',').filter((s) => s.length > 0).map(s => s.substr(0, 3)).filter(this.onlyUnique);
    console.log(list);
    commaString = list.join(',');
    if (this.chainCodeList !== commaString)
      this.chainCodeList = commaString;
  };
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  backupChainCodeList: string = '';
  get hotelChain(): boolean {
    return this.currentCustomer.HotelChain;
  }
  set hotelChain(enable: boolean) {
    this.currentCustomer.HotelChain = enable;
    if (enable) {
      this.chainCodeList = this.backupChainCodeList;
    } else {
      this.backupChainCodeList = this.chainCodeList;
      this.chainCodeList = '';
    }
  }
  IsValidBase64ForAmadeus(base64Str: string): boolean {
    try {
      if (!base64Str || typeof base64Str !== 'string') return false;
      const regex = /^[A-Za-z0-9+/]*={0,2}$/; // Allow optional padding
      return regex.test(base64Str);
    } catch {
      return false;
    }
    }
  isBusy: boolean = false;
  openModal: boolean = false;
  dialogTitle: string = "";
  dialogTextLine1: string = "";
  dialogTextLine2: string = '';
  cancelButton: string = null;
  onDialogDone: EventEmitter<boolean> = null;
  okCloseButtonClick(ok: boolean) {
    if (this.onDialogDone) {
      this.openModal = false;
      this.onDialogDone.next(ok);
    }
    if (this.onDeactivateDone) {
      this.openModal = false;
      this.onDeactivateDone.next(ok);
    }
  }
  confirmDlg(msg: string, title: string, cancelButton: boolean = false): EventEmitter<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.onDialogDone = new EventEmitter<boolean>();
    this.openModal = true;
    this.cancelButton = cancelButton ? "Cancel" : null;
    return this.onDialogDone;
  }

  constructor(
    private defaultsService: DefaultsService
    , private router: Router
    , private route: ActivatedRoute
    , private customerStateService: CustomersStateService
    , private customerService: CustomersService
    , private userProfileService:UserProfileService
  ) {
  }
  isAuthorizationUser:boolean = false;

  ngOnInit() {
    this.accountList = [
      { channelID: 0, clientID: 0, customerNumber: null, name: null, type: "", isTest: true }
    ];
    this.reset();
    this.isAuthorizationUser = (this.userProfileService.data.RoleList.includes("Super User") || this.userProfileService.data.CustomerName.toLowerCase() == "lanyonmaster") ;
    if(!this.isAuthorizationUser){
      this.okayToExit == true;
      this.userProfileService.TakeUserToLogoutPage();
    }
    else {
      
      this.loadAccountDropDown("Demand");
      const s1 = this.route
        .params.pipe(
          map(params => {
            return params.id || '';
          }))
        .subscribe(
          id => {
            this.customerID = id;
            if (id !== '') {
              this.isBusy = true;
              this.customerService.customerEditorLoadCustomer(id)
                .subscribe(
                  customer => this.loadCustomerFromService(customer)
                  , (err) => { this.isBusy = false; this.confirmDlg("Request Failed", "Failed", false); console.log(err); },
                  () => this.isBusy = false
                );
            }
          }
        );
      this.subscriptions.push(s1);
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  loadCustomerFromService(customer: CustomerModel) {
    this.currentCustomer = customer;
    this.chainCodeList = customer.ChainCodes.join(',')
    this.contract = customer.Contract;
    this.gdsCredentials = customer.GDSSecurityCredentials;
    this.inEditMode = true;
    this.disableChainCodes = customer.CustomerType != "Supply";
    this.CheckDropdownNameInEditMode();
  }
  testValidPullClass(inp:any){
    let ctrl:AbstractControl = inp as AbstractControl;
    return (ctrl.invalid && (this.highlightInvalidEntries))?'flagInvalid':'';
  }
  getByteCountFromBase64Length(base64Str: string): number {
    const base64Length = base64Str.trim().replace(/=+$/, '').length;
    const byteCount = Math.floor((base64Length * 3) / 4);
    return byteCount;
  }
  
  validateEntries(){
    let gdsCredentials = this.gdsCredentials;
    //Validate Amadeus credentials
    let errorMessage = ""; 
    if (gdsCredentials.AmadeusCredentials.Password && gdsCredentials.AmadeusCredentials.Password.trim() !== '') {

      if(!this.IsValidBase64ForAmadeus(gdsCredentials.AmadeusCredentials.Password)) {
        errorMessage = "Amadeus Password is not in base64 format.";
      }
      const calculatedDataLength = this.getByteCountFromBase64Length(gdsCredentials.AmadeusCredentials.Password);
      if (Number(gdsCredentials.AmadeusCredentials.DataLength) != calculatedDataLength) {
        errorMessage = errorMessage + " Amadeus Data length should be " + calculatedDataLength + ".";
      }
    }
    if (errorMessage != "") {
      this.confirmDlg(errorMessage, "Validation Error", false);
      return false;
      
    }

    if( this.customerForm.invalid)
      {
      this.highlightInvalidEntries=true;
      return false;
    }
    return true;
  }
  CustomerNameOrNew: string = "New Customer"
  onSaveCustomer() {
    if (!this.validateEntries())
    return;
    let saving = { ...this.currentCustomer };
    saving.Contract = this.contract;
    saving.GDSSecurityCredentials = this.gdsCredentials;
    saving.ChainCodes = this.chainCodeList.split(',');

    if (this.disableChainCodes == true && this.currentCustomer.QuickAudit == true && this.gdsCredentials.SabreCredentials.UseAAA == true && (!this.currentCustomer.SabreAAAPCC || this.currentCustomer.SabreAAAPCC.trim() == '')) {
      this.confirmDlg("Please enter Sabre PCC for Quick Audit", "Validation Error", false);
      return;
    }
  
    if (saving.CustomerId == 0 ) {
      this.customerService.customerEditorCreateNewCustomer(saving)
        .subscribe(
          customer => {
            this.loadCustomerFromService(customer);
            if (customer.CustomerId == 0) {
              this.confirmDlg("Customer was not saved", "Failed", false);
            }
            this.exitRoutine('New Customer Successfully Saved');
          }
          , (err) => { this.isBusy = false; this.confirmDlg("Error Saving Customer", "Failed", false); console.log(err); },
          () => this.isBusy = false
        );
    } else {
      this.customerService.customerEditorSaveCustomer(saving)
        .subscribe(
          ok => {
            console.log('customer saved ' + ok);
            this.exitRoutine('Customer Successfully Updated');
          }
          , (err) => { this.isBusy = false; this.confirmDlg("Error Saving Customer", "Failed", false); console.log(err); },
          () => this.isBusy = false
        );
    }
  }
  
  exitRoutine(title: string) { 
    let answerEvent = this.confirmDlg(title, "Success", false)
    if (!answerEvent) return;
    const s1 = answerEvent.subscribe(
      (userSaysOK) => {
        this.customerStateService.customerUpdate(this.currentCustomer);
        this.okayToExit = true;
        this.router.navigate(['../user-list'], { relativeTo: this.route });
      }
      , (err) => { console.log(err) }
    );
    this.subscriptions.push(s1);
  }

  threadsOptions: number[] = [10, 15, 20, 25, 30, 35, 40, 45, 50];
  dropdownPopupSettings: PopupSettings = {};
  contract: ContractModel = { ContractID: 0, CustomerID: 0, AuditAvl_BARReportExport: false, StandardRateAudit: false, AuditStd_LOSActive: false, RateAvailability: false, ReverseAudit: false };
  reset() {
    this.gdsCredentials = new GDSCredentials();
    this.currentCustomer = initCustomerModel();
    this.disableChainCodes = true;
    this.enableQuickAuditCheckBox = false;
    this.inEditMode = false;
    this.accountLinked = false;
    this.contract.StandardRateAudit = false;
    this.contract.AuditStd_LOSActive = false;
    this.contract.RateAvailability = false;
    this.contract.ReverseAudit = false;
    this.accountList=[];
    this.highlightInvalidEntries = false;
  }
  okayToExit: boolean = false;
  onCancel() {
    this.reset();
    this.okayToExit = true;
    this.router.navigate(['../user-list'], { relativeTo: this.route })
    this.customerStateService.customerUpdate(null);

  }
  gdsCredentials: GDSCredentials = new GDSCredentials();
  currentCustomer: CustomerModel;

  onLoadDefaultCredentials(assinger: (t: AddEditCustomerComponent, data: GDSCredentials) => void) {
    this.defaultsService.getDefaultGDSCredentials()
      .subscribe(data =>
        assinger(this, data)
      )
  }
  loadAmadeus(t: AddEditCustomerComponent, data: GDSCredentials): void {
    t.gdsCredentials.AmadeusCredentials = data.AmadeusCredentials;
  }
  loadApollo(t: AddEditCustomerComponent, data: GDSCredentials): void {
    t.gdsCredentials.ApolloCredentials = data.ApolloCredentials;
  }
  loadGalileo(t: AddEditCustomerComponent, data: GDSCredentials): void {
    t.gdsCredentials.GalileoCredentials = data.GalileoCredentials;
  }
  loadSabre(t: AddEditCustomerComponent, data: GDSCredentials): void {
    t.gdsCredentials.SabreCredentials = data.SabreCredentials;
  }
  loadWorldspan(t: AddEditCustomerComponent, data: GDSCredentials): void {
    t.gdsCredentials.WorldspanCredentials = data.WorldspanCredentials;
  }

  canDeactivate(): Observable<boolean> | boolean {
    // Allow synchronous navigation (`true`) if no crisis or the crisis is unchanged
    ;
    if (this.okayToExit == true)
      return true;

    if(this.isAuthorizationUser)
    {
      // Otherwise ask the user with the dialog service and return its
      // promise which resolves to true or false when the user decides
      let answerObservable = this.CanDeactivateDlg("Are you sure you wish to cancel edit on this customer."
       , "Any unsaved changes will be lost.", "Confirmation", true);
      return answerObservable;
    }
  }
  onDeactivateDone: Subject<boolean> = null;
  CanDeactivateDlg(msg: string, msg2: string, title: string, cancelButton: boolean = false): Observable<boolean> {
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.dialogTextLine2 = msg2;
    this.openModal = true;
    this.onDialogDone = null;
    this.onDeactivateDone = new Subject<boolean>();

    this.cancelButton = cancelButton ? "Cancel" : null;
    return this.onDeactivateDone.asObservable();

  }

  onDemandClick() {
    this.loadAccountDropDown("Demand");
    this.disableChainCodes = true;
  }

  onSupplyClick() {
    this.loadAccountDropDown("Supply");
    this.disableChainCodes = false;
  }

  linkedAccount_selectionChange(value: any) {
    this.currentCustomer.ChannelID = value.channelID;
    this.currentCustomer.ClientID = value.clientID;
    this.currentCustomer.CustomerNumber = value.customerNumber;
    this.currentCustomer.CustomerType = value.type;
    this.currentCustomer.CustomerName = value.name;
    this.enableQuickAuditCheckBox = value.type!=""; 
    if(value.type==""){ //if account
      this.currentCustomer.QuickAudit = false;
    }
}

  loadAccountDropDown(accountType: string) {
    this.isBusy = true;
    this.customerService.getCustomerAccountList(accountType).subscribe(data => {
      this.accountList = [
        { channelID: 0, clientID: 0, customerNumber: null, name: "(Account is not yet linked)", type: "", isTest: true }
      ];
      var adding = data.map(item => {
        return {
          name: item.name,
          channelID: item.channelID,
          clientID: item.clientID,
          customerNumber: item.customerNumber,
          type: item.type,
          isTest: item.isTest
        };
      }
      ).sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      })
      this.accountList = this.accountList.concat(adding);
      if (this.accountList != null) {
        if (!this.accountLinked) {
          this.currentCustomer.CustomerName = this.accountList[0].name;
          this.currentCustomer.ClientID = this.accountList[0].clientID;
          this.currentCustomer.ChannelID = this.accountList[0].channelID;
          this.currentCustomer.CustomerNumber = this.accountList[0].customerNumber;
          this.currentCustomer.CustomerType=this.accountList[0].type;
        }
      }
    }, (err) => { this.isBusy = false; this.confirmDlg("Request Failed", "Failed", false); console.log(err); },

    () => this.isBusy = false);

  }

  CheckDropdownNameInEditMode() {

    this.accountLinked = false;
    if (this.inEditMode) {
      if (this.currentCustomer.CustomerType == "Supply") {
        this.CustomerNameOrNew = "Supply-" + this.currentCustomer.CustomerNumber + "-" + this.currentCustomer.CustomerName
      }
      else if (this.currentCustomer.CustomerType == "Master") {
        this.CustomerNameOrNew = "TMC-" + this.currentCustomer.ClientID + "-" + this.currentCustomer.CustomerName
      }
      else if ( ["Master","Consortia Advanced","Corporation"].includes( this.currentCustomer.CustomerType) ) {
        this.CustomerNameOrNew = "Corp-" + this.currentCustomer.ClientID + "-" + this.currentCustomer.CustomerName
      }
      else {
        this.CustomerNameOrNew = "";
      }
      this.accountLinked = this.CustomerNameOrNew != "";
      this.enableQuickAuditCheckBox = this.accountLinked;
    }
  }

}
